import { Outlet, useLocation } from 'react-router'

import { DelayRender } from '@fortem-monorepo/react-spa'

import { useLayoutContext } from '@/layout.context'

export interface LayoutOutletProps {}

export const LayoutOutlet: React.FC<LayoutOutletProps> = () => {
  const { pathname } = useLocation()
  const layoutContext = useLayoutContext()

  return (
    <DelayRender key={pathname}>
      <div className={'flex flex-col flex-1 fade-in duration-400 animate-in'}>
        <Outlet context={layoutContext} />
      </div>
    </DelayRender>
  )
}
